import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const TimerNode = ({ id, data }) => {
  const [delay, setDelay] = useState(data?.delay || 1000);
  const [enabled, setEnabled] = useState(data?.enabled ?? true);

  const config = {
    title: 'Timer',
    content: (
      <div className="text-xs text-gray-500 mb-2">
        Delay execution by specified time
      </div>
    ),
    fields: [
      {
        name: 'delay',
        type: 'number',
        label: 'Delay (ms)',
        value: delay,
        onChange: (e) => setDelay(e.target.value),
        placeholder: '1000',
        min: 0,
        step: 100,
      },
      {
        name: 'enabled',
        type: 'checkbox',
        label: 'Enabled',
        value: enabled,
        onChange: (e) => setEnabled(e.target.checked),
      },
    ],
    handles: [
      {
        type: 'target',
        position: Position.Left,
        id: `${id}-trigger`,
      },
      {
        type: 'source',
        position: Position.Right,
        id: `${id}-output`,
      },
    ],
    width: 220,
    height: 150,
  };

  return <BaseNode id={id} data={data} config={config} />;
};